export const SMS_CODE_LENGTH = 4

export const AUTH_REDIRECTED_FROM_KEY = 'x-auth-redirected-from'

export const REFRESH_TOKEN_RETRY_DELAYS_MS = [5000, 10_000, 30_000] as const

export const INVITE_HAS_EXPIRED_TITLE = 'invite_has_expired'
export const INVITE_USER_CREATED_TITLE = 'invite_user_created'
export const INVITE_NOT_FOUND_TITLE = 'invite_not_found'
export const EMAIL_IS_ALREADY_IN_USE_ERROR = 'email_already_exists'
export const INVITE_IS_ALREADY_ACCEPTED_ERROR = 'invite_already_accepted'
export const SESSION_CREATION_ERROR = 'session_creation_error'
export const USER_DISABLED_ERROR = 'User disabled'
